module.exports = __webpack_public_path__ + "img/avatar.c5e00bae.png";